/* Carpathian Trans — shared front-end behavior
   Safety-first: content is visible without JS; animations are transform-only,
   scroll-position based (no IntersectionObserver), with timed force-settle. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Mobile nav toggle ---------- */
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.querySelector('.main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('.site-header');

  /* ---------- Scroll progress bar ---------- */
  var progress = document.querySelector('.scroll-progress');

  /* ---------- Scroll reveal (transform only) ---------- */
  var revealEls = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));

  function checkReveals() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = revealEls.length - 1; i >= 0; i--) {
      var el = revealEls[i];
      var rect = el.getBoundingClientRect();
      if (rect.top < vh * 0.92 || rect.bottom < vh) {
        el.classList.add('is-revealed');
        revealEls.splice(i, 1);
      }
    }
  }

  /* ---------- Stat count-up ---------- */
  var stats = Array.prototype.slice.call(document.querySelectorAll('[data-countup]'));

  function animateStat(el) {
    var original = el.textContent;
    var match = original.match(/[\d,.]+/);
    if (!match || reducedMotion) return;
    var target = parseFloat(match[0].replace(/,/g, ''));
    if (!isFinite(target)) return;
    var prefix = original.slice(0, match.index);
    var suffix = original.slice(match.index + match[0].length);
    var start = null;
    var duration = 1400;
    var restored = false;

    function restore() {
      if (!restored) { restored = true; el.textContent = original; }
    }

    function frame(ts) {
      if (restored) return;
      if (start === null) start = ts;
      var t = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      var value = Math.round(target * eased);
      el.textContent = prefix + value.toLocaleString('en-US') + suffix;
      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        restore();
      }
    }
    requestAnimationFrame(frame);
    /* Safety net: exact original text always comes back */
    setTimeout(restore, duration + 600);
  }

  function checkStats() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = stats.length - 1; i >= 0; i--) {
      var rect = stats[i].getBoundingClientRect();
      if (rect.top < vh * 0.92 && rect.bottom > 0) {
        animateStat(stats[i]);
        stats.splice(i, 1);
      }
    }
  }

  /* ---------- rAF-throttled scroll handler ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      if (header) header.classList.toggle('is-scrolled', scrollY > 8);
      if (progress) {
        var doc = document.documentElement;
        var max = doc.scrollHeight - doc.clientHeight;
        progress.style.width = max > 0 ? (Math.min(scrollY / max, 1) * 100) + '%' : '0%';
      }
      checkReveals();
      checkStats();
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();
  /* Re-check shortly after load (fonts/layout shifts) */
  setTimeout(onScroll, 250);
  setTimeout(onScroll, 1000);

  /* ---------- Infinite scroll for the products/catalog grid ----------
     Works two ways off the same code:
       • data-infinite-demo  → clones the sample cards in batches (static preview)
       • data-next-url        → fetches the next Shopify page and appends its cards */
  function initInfinite() {
    var grid = document.querySelector('[data-infinite-grid]');
    if (!grid) return;
    var status = document.querySelector('[data-infinite-status]');
    var loading = false;
    var done = false;
    var demo = grid.hasAttribute('data-infinite-demo');
    var demoTemplate = demo ? Array.prototype.slice.call(grid.children).map(function (c) { return c.cloneNode(true); }) : null;
    var demoBatches = 0;
    var demoMax = 3;

    function setStatus(text, spinning) {
      if (!status) return;
      status.textContent = text || '';
      if (spinning) { status.setAttribute('data-loading', ''); }
      else { status.removeAttribute('data-loading'); }
    }

    function nearBottom() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      return grid.getBoundingClientRect().bottom - vh < 650;
    }

    function settle(card) {
      card.classList.add('is-revealed');
      card.style.transform = 'none';
    }

    function finish(message) {
      done = true;
      setStatus(message, false);
    }

    function loadMore() {
      if (loading || done || !nearBottom()) return;

      if (demo) {
        loading = true;
        demoBatches++;
        demoTemplate.forEach(function (t) {
          var c = t.cloneNode(true);
          settle(c);
          grid.appendChild(c);
        });
        loading = false;
        if (demoBatches >= demoMax) { finish('That’s everything (sample data)'); }
        else if (nearBottom()) { loadMore(); }
        return;
      }

      var nextUrl = grid.getAttribute('data-next-url');
      if (!nextUrl) { finish(''); return; }
      loading = true;
      setStatus('Loading more', true);
      fetch(nextUrl, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-infinite-grid]');
          var cards = newGrid ? newGrid.querySelectorAll('.product-card') : [];
          Array.prototype.forEach.call(cards, function (c) { settle(c); grid.appendChild(c); });
          var next = newGrid ? (newGrid.getAttribute('data-next-url') || '') : '';
          grid.setAttribute('data-next-url', next);
          loading = false;
          if (!next) { finish(''); }
          else { setStatus('', false); if (nearBottom()) { loadMore(); } }
        })
        .catch(function () {
          loading = false;
          setStatus('Couldn’t load more — scroll to retry', false);
        });
    }

    var sentinel = status || grid;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { loadMore(); break; }
        }
      }, { rootMargin: '700px 0px' });
      io.observe(sentinel);
    }
    /* Scroll/resize fallback (and covers browsers without IO) */
    window.addEventListener('scroll', loadMore, { passive: true });
    window.addEventListener('resize', loadMore, { passive: true });
    loadMore();
  }
  initInfinite();

  /* ---------- Force-settle safety net ----------
     After 4s, everything animates to its final state no matter what. */
  setTimeout(function () {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.classList.add('is-revealed');
    });
    document.querySelectorAll('[data-hero-step]').forEach(function (el) {
      el.style.animation = 'none';
      el.style.transform = 'none';
    });
  }, 4000);
})();
